import React from 'react'

export const WizardContext = React.createContext({})
